




























































































import { Vue, Component, Prop, Inject } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { Permission } from "@/shared/types";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import moment from "moment";
import CompanyHelper from "./CompanyHelper";
import UmbOnboardingInfo from "@/employer/components/resources/UmbOnboardingInfo.vue";
import AvidiaOnboardingInfo from "@/employer/components/resources/AvidiaOnboardingInfo.vue";
import AllegacyOnboardingInfo from "@/employer/components/resources/AllegacyOnboardingInfo.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";


@Component ({
  components: {
    Input,
    Button,
    UmbOnboardingInfo,
    AvidiaOnboardingInfo,
    AllegacyOnboardingInfo
  }
})
export default class BankInfo extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Inject() $validator: Validator;

  @Prop()
  bankInformation: any; // EmployerAccounts;

  editFundingBankAccount = false;
  resetAgreeOnEdit = false;

  fundingBankAccountConfirm = "";

  companyHelper: CompanyHelper;

  created () {
    const fundingBa = this.bankInformation.fundingAccount;
    this.fundingBankAccountConfirm = fundingBa.bankAccountNumber;
    this.bankInformation.feeAccount = fundingBa;

    this.setDirtyState();
    this.companyHelper = new CompanyHelper(this.bankInformation);

    this.custodianSettingsStore.getEmployerCustodian();
  }

  editFundingAccountClick () {
    this.editFundingBankAccount = true;
    this.bankInformation.authorizationDate = null;
    this.resetAgreeOnEdit = true;
  }

  get debitAgreementValue () {
    return (!!this.bankInformation.authorizationDate);
  }

  set debitAgreementValue (didAgree: boolean) {
    if (didAgree) {
      this.bankInformation.authorizationDate = moment.utc().format();
    } else {
      this.bankInformation.authorizationDate = "";
    }
  }

  setDirtyState () {
    const fundingBa = this.bankInformation.fundingAccount;

    this.editFundingBankAccount = !fundingBa.bankAccountNumber;
  }

  get shouldShowDebitAgreementField () {
    return this.resetAgreeOnEdit ? this.resetAgreeOnEdit : !!this.companyHelper.bankAccountFeeConfirmFieldIsRequired;
  }

  get hasBankAccountWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.BankAccountWrite);
  }
}

